/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IWarrantyViewProps } from './warranty';

export default (props: IWarrantyViewProps) => {
    return (
        <div className='default-container default-container container'>
            <div className='row'>
                <div className={` ${props.config.cusBootstrapClassLeft}`}>
                    {props.config.cusTextfield}
                </div>
                <div className={` ${props.config.cusBootstrapClassRight}`}>
                    <div className='ms-iframe warranty-form mt-3' id='' data-m-t='iframe'>
                        <h2 className='ms-iframe__heading'>{props.config.cusIframeHeading}</h2>
                        <iframe
                            className='ms-iframe__content'
                            src={props.config.cusIframeSrc}
                            height='100%'
                            aria-label={`${props.config.cusIframeAriaLabel}`}
                        ></iframe>
                    </div>
                </div>
            </div>
        </div>
    );
};
